import type { ConditionGroup, OfferDefinition } from '../../libs/offerSystem/offerSystemTypes';
import type { Condition } from '../offers/conditionsTypes';
import type { OffersGameData } from '../offers/offersTypes';
import { conditions } from '../offers/conditions';

function validateCondition(condition: Condition | ConditionGroup<Condition>): void {
  if ('groupType' in condition) {
    condition.conditions.forEach((conditionInGroup) => {
      validateCondition(conditionInGroup);
    });
    return;
  }

  const handler = conditions[condition.type];
  if (!handler) {
    throw new Error(`Cannot find condition handler for ${condition.type}`);
  }

  Object.entries(handler.createNew())
    .map(([key, value]) => [key, typeof value])
    .forEach(([key, typeOfValue]) => {
      if (typeof condition[key as keyof Condition] !== typeOfValue) {
        throw new Error(`Property ${key} of condition ${condition.type} has a wrong type`);
      }
    });
}

function validateOffers(offers: OfferDefinition<Condition, OffersGameData>[]): void {
  offers.forEach((offer) => {
    if (offer.startConditions) validateCondition(offer.startConditions);
    if (offer.endConditions) validateCondition(offer.endConditions);
    offer.variants.forEach((variant) => {
      if (variant.conditions) validateCondition(variant.conditions);
    });
  });
}

export async function loadRemoteOfferConfig(url: string): Promise<OfferDefinition<Condition, OffersGameData>[] | null> {
  try {
    const response = await fetch(url);
    if (!response.ok) return null;
    const offersToValidate = (await response.json()) as OfferDefinition<Condition, OffersGameData>[];
    validateOffers(offersToValidate);
    return offersToValidate;
  } catch (e) {
    console.warn(`Invalid remote config with offers`, e);
    return null;
  }
}
